import React, { useCallback, useMemo, useState } from 'react';

import { createFeatureGridData } from './feature-grid-data/create-feature-grid-data';
import { FeatureGroupSection } from './feature-section/feature-group-section';

/**
 * @typedef {import('../../../../../../prop-types/subscription-data-types.d.ts').SubscriptionData} SubscriptionData
 */

const INITIAL_EXPANDED_SECTIONS_COUNT = 3;

const createInitialExpanderState = (featureGroups) => {
  return featureGroups.reduce((acc, featureGroup, index) => {
    return {
      ...acc,
      [featureGroup.featureGroupId]: index < INITIAL_EXPANDED_SECTIONS_COUNT,
    };
  }, {});
};

/**
 * @param {object} props
 * @param {string} props.currentBillingPlanId
 * @param {string} [props.selectedBillingPlanId]
 * @param {SubscriptionData} props.subscriptionData
 * @returns {React.JSX.Element[]}
 */
export const FeaturesGrid = ({ currentBillingPlanId, selectedBillingPlanId, subscriptionData }) => {
  const featureGroups = useMemo(() => {
    return createFeatureGridData(subscriptionData);
  }, [subscriptionData]);

  const [expandedSections, setExpandedSections] = useState(() => createInitialExpanderState(featureGroups));

  const toggleSectionIsExpanded = useCallback((featureGroupId) => {
    setExpandedSections((prev) => ({
      ...prev,
      [featureGroupId]: !prev[featureGroupId],
    }));
  }, []);

  return featureGroups.map((featureGroup, index) => {
    const isLastSection = featureGroups.length - 1 === index;

    return (
      <FeatureGroupSection
        key={featureGroup.featureGroupId}
        currentPlanId={currentBillingPlanId}
        featureGroup={featureGroup}
        isExpanded={expandedSections[featureGroup.featureGroupId]}
        isLastSection={isLastSection}
        onToggle={toggleSectionIsExpanded}
        plans={subscriptionData.allPlans}
        selectedPlanId={selectedBillingPlanId}
      />
    );
  });
};
